import uuid from 'uuid/v4';

const AGENDA_PAGE_URL_DYNAMIC_TAB = '[sessions_page]';

export const AGENDA_BUTTON_META = {
    content: 'Manage Agenda',
    displayName: 'Custom Button',
    href: AGENDA_PAGE_URL_DYNAMIC_TAB,
};

function nodeIsAgendaPageButton(node) {
    return node.type === 'Button' && node.meta?.href === AGENDA_PAGE_URL_DYNAMIC_TAB;
}

function buildAgendaButtonNode() {
    const id = uuid();
    const defaultElementProperties = {
        props: {
            meta: AGENDA_BUTTON_META,
        },
    };
    return { type: 'Button', id, ...defaultElementProperties };
}

function removeRemoveElementsToAddParamFromUrl(urlString) {
    const urlObj = new URL(urlString);
    const params = urlObj.searchParams;
    params.delete('add-elements');
    window.history.replaceState(null, '', urlObj.toString());
}

function addNewNodeToConfirmationModal(newNode, nodes, actions) {
    const modalElement = Object.values(nodes).find((node) => node.type === 'Modal');
    actions.addNodeAsChild(newNode, modalElement.id);
    actions.selectNode(newNode.id);
}

export function useAddElementsByUrl(confirmationNodes, editorActions) {
    const areNodesLoaded = Object.values(confirmationNodes).length > 0;
    const params = new URLSearchParams(window.location.search);
    const elementsToAddParam = params.get('add-elements') || '';
    const needToAddAgendaPageButton = elementsToAddParam.split(',').includes('agenda-page-button');
    const confirmationContainsAgendaPageButton = Object.values(confirmationNodes).some(nodeIsAgendaPageButton);
    if (areNodesLoaded && needToAddAgendaPageButton && !confirmationContainsAgendaPageButton) {
        const newNode = buildAgendaButtonNode();
        addNewNodeToConfirmationModal(newNode, confirmationNodes, editorActions);
        removeRemoveElementsToAddParamFromUrl(window.location);
    }
    return confirmationNodes;
}
